<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li *ngIf="this.loginPersonType != 'Business Admin'"><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material
          </a><a *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a>Products</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home" *ngIf="loginUserBusinessCategory != 'Provider'"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
          <a routerLink="/home/dashboard" *ngIf="loginUserBusinessCategory == 'Provider'"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
        </div>
      </div>
    </div>
    <div class="block"
         *ngIf="(['Farmer', 'Farm Manager', 'Business Admin'].includes(this.loginPersonType) && loginUserBusinessCategory == 'Farm') || this.loginPersonType == 'EMPLOYEE'">
      <div class="page-header">
        <span class="page-header__title">Products</span>
      </div>
      <div class="Reports_form_div">
        <form role="form" name="addmapdevice">
          <div class="reports-form-container">
            <mat-form-field appearance="outline" class="w-100"  *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>System</mat-label>
              <mat-select id="system" [disabled]="formAction == 'EDIT'" name="system"
                          [(ngModel)]="itemMaster.system" (selectionChange)="displaytabledata();this.clearSearchInput = false">
                <mat-option value="undefined" disabled>Select System</mat-option>
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100"  *ngIf="(itemMaster.system===false) && (loginPersonType == 'EMPLOYEE')">
              <mat-label>Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" [disabled]="formAction == 'EDIT'" name="business"
                     placeholder="Search business" (keyup)="filterBusinesses($event)" [(ngModel)]="selectedBusinessName"
                     (focus)="filteredOptions = businessEntities" [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="form-field" *ngIf="loginPersonType != 'EMPLOYEE'">
              <div class="farmer-manager-business">
                <label style="left: 23px; top: 5px">Farm</label>
                <p style="font-size: 15px;font-weight: 500;">{{ loginUserBusinessName }}</p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="responseLoader">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="panel"
         *ngIf="((['Farmer', 'Farm Manager', 'Business Admin'].includes(this.loginPersonType) && loginUserBusinessCategory == 'Farm') || this.loginPersonType == 'EMPLOYEE') && !responseLoader">
      <div class="row">
        <div class="list_block" *ngIf="dubItemmasters && dubItemmasters.length > 0 || NoDataMessage">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (keyup)="searchItemMaster($event)" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by item type name"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div class="businessCardsData" *ngIf="filteredProductArray && filteredProductArray.length>0 && !responseLoader"
             [ngClass]="{'businessCardsData' : filteredProductArray && filteredProductArray.length> 5 }">
          <div *ngIf="filteredProductArray && filteredProductArray.length > 0">
            <div *ngFor="let eachFilteredArray of filteredProductArray;let i = index">
              <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length > 0">
                <p
                  class="col-xs-11">{{ eachFilteredArray && eachFilteredArray[0] && eachFilteredArray[0].ItemType && eachFilteredArray[0].ItemType.name }}</p>
                <p class="col-xs-1">{{ eachFilteredArray.length }}</p>
              </div>
              <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                <p
                  class="col-xs-11">{{ (itemTypes && itemTypes[i] && itemTypes[i].name) ? (itemTypes && itemTypes[i] && itemTypes[i].name) : '' }}</p>
                <p class="col-xs-1">0</p>
              </div>
              <hr *ngIf="eachFilteredArray && eachFilteredArray.length >= 0">
              <div class="row dashboard-cards">
                <div class="card col-lg-3 mb-4 searchfun" *ngFor="let item of eachFilteredArray"
                     (mouseenter)="showCardActions($event)" (mouseleave)="hideCardActions($event)">
                  <div class="card-title">
                    <h2>
                      <img *ngIf="item.attachment_path == null" (click)="getProductProfileById(item.id)"
                           src="../../../../../../assets/img/DefalutImages/Feed.png" width="158" height="194"/>
                      <img *ngIf="item.attachment_path != null" [src]="item.attachment_path" width="158"
                           height="194"/>
                    </h2>
                    <div class="edit-icon" (click)="setItemMasterDetails(item)" title="Edit Product"
                         data-target="#addUpdateModal">
                      <img src="assets/images/New_Icons/edit.svg" alt="Edit Icon"/>
                    </div>
                    <div class="product-name"
                         title="{{item && item.item_name}}">{{ (item.item_name.slice(0, 15)) || 'NA' }}<span
                      *ngIf="item && item.item_name.length > 15">...</span></div>
                  </div>
                  <div class="card-flap flap1">
                    <div class="card-description">
                      <ul class="task-list">
                        <li>{{ item.sub_type == null ? 'NA' : item.sub_type }}</li>
                        <li
                          *ngIf="item && item.UOMConversion.length> 0">{{ (item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value) ? item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value : '' }}
                          /{{ (item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name)) ? item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name) : '' }}
                        </li>
                        <li>{{ item.description }}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="row row-flex notfoundtext" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">No
                  Products Found
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="NoDataMessage" class="noDataFoundMessage">No Data Available</div>
    </div>
    <!--if login person type is business admin-->
    <div class="block" *ngIf="loginPersonType == 'Business Admin' && loginUserBusinessCategory == 'Provider' && !responseLoader">
      <div class="screen_heading_div">
        <span>Products</span>
      </div>
      <div class="nav_tabs_container">
        <ul>
          <li class="active" data-toggle="tab" href="#inventory"><a>Your Catalogue</a></li>
          <li data-toggle="tab" href="#expense"><a>Expense Items (System Provided)</a></li>
        </ul>
      </div>
      <div class="row">
        <div class="tab-content">
          <div id="inventory" class="tab-pane fade in active">
            <div class="search_cum_icons_button_container">
              <div class="search-div">
                <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
                <input type="text" (keyup)="searchItemMaster($event)" [(ngModel)]="search" name="search"
                       autocomplete="off"
                       placeholder="Search by product">
              </div>
              <div class="add-button-container" (click)="openForm()" data-toggle="modal"
                   data-target="#addUpdateModal" data-backdrop="static" data-keyboard="false">
                <button class="button">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Plus icon"></span>
                  <span class="text">Add New</span>
                </button>
              </div>
            </div>
            <div class="businessCardsData"
                 [ngClass]="{'businessCardsData' : (yourCatalogueProductArray && yourCatalogueProductArray.length> 5) }">
              <div *ngIf="yourCatalogueProductArray && yourCatalogueProductArray.length > 0">
                <div *ngFor="let eachFilteredArray of yourCatalogueProductArray;let i = index">
                  <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length > 0">
                    <p
                      class="col-xs-11">{{ eachFilteredArray && eachFilteredArray[0] && eachFilteredArray[0].ItemType && eachFilteredArray[0].ItemType.name }}</p>
                    <p class="col-xs-1">{{ eachFilteredArray.length }}</p>
                  </div>
                  <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                    <p
                      class="col-xs-11">{{ (itemTypes && itemTypes[i] && itemTypes[i].name) ? (itemTypes && itemTypes[i] && itemTypes[i].name) : '' }}</p>
                    <p class="col-xs-1">0</p>
                  </div>
                  <hr *ngIf="eachFilteredArray && eachFilteredArray.length >= 0">
                  <div class="row dashboard-cards">
                    <div class="card col-lg-3 mb-4 searchfun" *ngFor="let item of eachFilteredArray"
                         (mouseenter)="showCardActions($event)" (mouseleave)="hideCardActions($event)">
                      <div class="card-title">
                        <h2>
                          <img *ngIf="item.attachment_path == null" (click)="getProductProfileById(item.id)"
                               src="../../../../../../assets/img/DefalutImages/Feed.png" width="158" height="194"/>
                          <img *ngIf="item.attachment_path != null" [src]="item.attachment_path" width="158"
                               height="194"/>
                        </h2>
                        <div class="edit-icon" (click)="setItemMasterDetails(item)" title="Edit Product"
                             data-target="#addUpdateModal">
                          <img src="assets/images/New_Icons/edit.svg" alt="Edit Icon"/>
                        </div>
                        <div class="product-name"
                             title="{{item && item.item_name}}">{{ (item.item_name.slice(0, 15)) || 'NA' }}<span
                          *ngIf="item && item.item_name.length > 15">...</span></div>
                      </div>
                      <div class="card-flap flap1">
                        <div class="card-description">
                          <ul class="task-list">
                            <li>{{ item.sub_type == null ? 'NA' : item.sub_type }}</li>
                            <li
                              *ngIf="item && item.UOMConversion && item.UOMConversion.length> 0">{{ (item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value) ? item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value : '' }}
                              /{{ (item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name)) ? item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name) : '' }}
                            </li>
                            <li>{{ item.description }}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row row-flex notfoundtext" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                      No Products Found
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="expense" class="tab-pane fade">
            <div class="row" style="clear: both">
              <div class="col-xs-12">
                <div class="businessSearchboxstyle"
                     *ngIf="(this.isSearchClicked || ((originalItemMasters && originalItemMasters.length>0) && !this.isSearchClicked))">
                  <div class="search_cum_icons_button_container">
                    <div class="search-div">
                      <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
                      <input type="text" (keyup)="searchItemMaster($event)" [(ngModel)]="search" name="search"
                             autocomplete="off" placeholder="Search by product">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="businessCardsData"
                 [ngClass]="{'businessCardsData' : expenseCatalogueProductArray && expenseCatalogueProductArray.length> 5 }">
              <div *ngIf="expenseCatalogueProductArray && expenseCatalogueProductArray.length > 0">
                <div *ngFor="let eachFilteredArray of expenseCatalogueProductArray;let i = index">
                  <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length > 0">
                    <p
                      class="col-xs-11">{{ eachFilteredArray && eachFilteredArray[0] && eachFilteredArray[0].ItemType && eachFilteredArray[0].ItemType.name }}</p>
                    <p class="col-xs-1">{{ eachFilteredArray.length }}</p>
                  </div>
                  <div class="row businessheading" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                    <p
                      class="col-xs-11">{{ (itemTypes && itemTypes[i] && itemTypes[i].name) ? (itemTypes && itemTypes[i] && itemTypes[i].name) : '' }}</p>
                    <p class="col-xs-1">0</p>
                  </div>
                  <hr *ngIf="eachFilteredArray && eachFilteredArray.length >= 0">
                  <div class="row dashboard-cards">
                    <div class="card col-lg-3 mb-4 searchfun" *ngFor="let item of eachFilteredArray"
                         (mouseenter)="showCardActions($event)" (mouseleave)="hideCardActions($event)">
                      <div class="card-title">
                        <h2>
                          <img *ngIf="item.attachment_path == null" (click)="getProductProfileById(item.id)"
                               src="../../../../../../assets/img/DefalutImages/Feed.png" width="158" height="194"/>
                          <img *ngIf="item.attachment_path != null" [src]="item.attachment_path" width="158"
                               height="194"/>
                        </h2>
                        <div class="edit-icon" (click)="setItemMasterDetails(item)" title="Edit Product"
                             data-target="#addUpdateModal">
                          <img src="assets/images/New_Icons/edit.svg" alt="Edit Icon"/>
                        </div>
                        <div class="product-name"
                             title="{{item && item.item_name}}">{{ (item.item_name.slice(0, 15)) || 'NA' }}<span
                          *ngIf="item && item.item_name.length > 15">...</span></div>
                      </div>
                      <div class="card-flap flap1">
                        <div class="card-description">
                          <ul class="task-list">
                            <li>{{ item.sub_type == null ? 'NA' : item.sub_type }}</li>
                            <li
                              *ngIf="item && item.UOMConversion && item.UOMConversion.length> 0">{{ (item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value) ? item && item.UOMConversion.length > 0 && item.UOMConversion[0].to_value : '' }}
                              /{{ (item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name)) ? item && item.UOMConversion.length > 0 && (item.UOMConversion[0].ToUOM && item.UOMConversion[0].ToUOM.name) : '' }}
                            </li>
                            <li>{{ item.description }}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row row-flex notfoundtext" *ngIf="eachFilteredArray && eachFilteredArray.length == 0">
                      No Products Found
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="NoDataMessage" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
    <!--product profile-->
    <div class="modal fade right" id="myModal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;
            </button>
            <h4 class="modal-title">Product</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="col-xs-8">
                  <img src="../../../../../../assets/img/productImages/02.jpeg" height="300" width="100%"/>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <p><img src="../../../../../../assets/img/productImages/04.jpeg" height="95" width="100%"/></p>
                  <p><img src="../../../../../../assets/img/productImages/05.jpeg" height="95" width="100%"/></p>
                  <p><img src="../../../../../../assets/img/productImages/07.jpeg" height="95" width="100%"/></p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <p class="selectItem">{{ itemMaster.item_name }}</p>
                <p class="selectsubtype">Sub Type</p>
                <p class="selectprice">Price/Kg or Pack</p>
                <p>Dosage</p>
              </div>
            </div>
            <div class="row productDetails">
              <div class="col-xs-12">
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                  <p>Top sales</p>
                  <p>100</p>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                  <p>Sales last month</p>
                  <p>100 Pcs</p>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                  <p>Top Customer</p>
                  <p>Test Customer</p>
                </div>
                <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                  <p>Top User</p>
                  <p>Iprotechs</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--add/update form-->
    <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
      <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
      <!--outside close-->
      <div class="popup-wrapper">
        <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
        <!-- Actual Popup -->
        <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
          <form [formGroup]="registerForm" novalidate>
            <div class="form-header">
              <div class="form-title">Product</div>
              <button class="add-update-submit-button" (click)="submitButton ? addItemMaster() : updateItemMaster()" [disabled]="addProductDoubleClick">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
              </button>
            </div>
            <div class="form-container">
              <div class="form-section">
                <div class="grid-three-cols">
                  <!--product name-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Product name</mat-label>
                    <input matInput id="activityName" name="itemname" type="text" [(ngModel)]="itemMaster.item_name" formControlName="productname" autocomplete="off" placeholder="Product Name"/>
                    <!-- Hint -->
                    <mat-hint><i>2–30 alphabetic characters</i></mat-hint>
                    <!-- Single dynamic error -->
                    <mat-error *ngIf="(f.productname.dirty || f.productname.touched || submitted) && f.productname.errors">
                      <i> {{f.productname.hasError('required') ? 'Product name is required.': f.productname.hasError('minlength')? 'Minimum 2 characters required.': f.productname.hasError('maxlength')
                        ? 'Maximum 30 characters allowed.' : f.productname.hasError('pattern') ? 'Special characters not allowed.': ''}}</i>
                    </mat-error>
                  </mat-form-field>
                  <!--subtype-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Sub Type</mat-label>
                    <input matInput id="subtype" type="text" autocomplete="off" [(ngModel)]="itemMaster.sub_type" formControlName="subtype" placeholder="Enter sub type"/>
                    <mat-hint><i>2-30 alphabetic characters</i></mat-hint>
                    <mat-error *ngIf="f.subtype.value?.length > 0 && f.subtype.errors">
                      <i>
                        {{ f.subtype.hasError('minlength') ? 'Minimum 2 characters required.' :
                        f.subtype.hasError('maxlength') ? 'Maximum 30 characters allowed.' :
                          f.subtype.hasError('pattern') ? 'Special characters not allowed.' : '' }}
                      </i>
                    </mat-error>
                  </mat-form-field>
                  <!--shape-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Shape/Form</mat-label>
                    <mat-select id="shape" [(ngModel)]="itemMaster.shape_id" formControlName="shape">
                      <mat-option value="" disabled>Select shape</mat-option>
                      <mat-option *ngFor="let shape of shapes" [value]="shape.id"> {{ shape.name }} </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="f.shape.invalid"><i>Select shape</i></mat-hint>
                    <mat-hint *ngIf="f.shape.valid"><i>Shape selected</i></mat-hint>
                  </mat-form-field>
                  <!--pellet size-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Pellet Size</mat-label>
                    <input matInput id="pelletsize" type="text" (selectionChange)="pelletSize()" autocomplete="off" [(ngModel)]="itemMaster.pellet_size" formControlName="pelletsize" placeholder="Enter pellet size"/>
                    <mat-hint><i>Only numbers</i></mat-hint>
                    <mat-error *ngIf="f.pelletsize.value?.length > 0 && f.pelletsize.hasError('pattern')">
                      <i>Only numbers are allowed.</i>
                    </mat-error>
                  </mat-form-field>
                  <!--usage-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Usage</mat-label>
                    <input matInput id="usage" type="text" autocomplete="off" [(ngModel)]="itemMaster.usage" formControlName="usage" placeholder="Enter usage"/>
                    <mat-hint><i>Max 30 characters. Only comma (,), dot (.), hyphen (-), and space allowed.</i></mat-hint>
                    <mat-error *ngIf="f.usage.value?.length > 0 && f.usage.errors">
                      <i>
                        {{ f.usage.hasError('maxlength') ? 'Maximum 30 characters allowed.' :
                        f.usage.hasError('pattern') ? 'Only comma (,), dot (.), hyphen (-), and space allowed.' : '' }}
                      </i>
                    </mat-error>
                  </mat-form-field>
                  <!--dosage-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Dosage</mat-label>
                    <input matInput id="dosage" type="text" autocomplete="off" [(ngModel)]="itemMaster.dosage" formControlName="dosage" placeholder="Enter dosage"/>
                    <mat-hint><i>Min 30 characters. Only comma (,), dot (.), hyphen (-), and space allowed.</i></mat-hint>
                    <mat-error *ngIf="f.dosage.value?.length > 0 && f.dosage.errors">
                      <i>
                        {{ f.dosage.hasError('maxlength') ? 'Maximum 30 characters allowed.' :
                        f.dosage.hasError('pattern') ? 'Only slash (/), dot (.), hyphen (-), and space allowed.' : '' }}
                      </i>
                    </mat-error>
                  </mat-form-field>
                  <!--description-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Description</mat-label>
                    <textarea matInput id="activityDescription" [(ngModel)]="itemMaster.description" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                    <mat-hint><i>Up to 200 characters</i></mat-hint>
                    <mat-error *ngIf="f.description.value?.length > 0 && f.description.errors">
                      <i> {{ f.description.hasError('maxlength') ? 'Maximum 200 characters allowed.' : '' }} </i>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-section">
                <div class="grid-three-cols">
                  <!--product type-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Product Type</mat-label>
                    <mat-select id="producttyep"  formControlName="itemtype" [(ngModel)]="itemMaster.item_type_id"
                                (selectionChange)="productChange();updateToggleSwitchState(); itemMaster.culture_category_id = undefined; itemMaster.species_type_id = undefined; conversionBlock = false; conversion.from_units_uom_id = null; conversion.to_value = undefined; conversion.to_units_uom_id = null; itemMaster.uom_id = undefined; itemMaster.reorder_level_value = null; itemMaster.reorder_uom_id = undefined; UOMName = undefined">
                      <mat-option value="" disabled>Select Product Type</mat-option>
                      <mat-option *ngFor="let item of itemTypes" [value]="item.id"> {{ item.name }} </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="f.itemtype.invalid"><i>Select product type</i></mat-hint>
                    <mat-hint *ngIf="f.itemtype.valid"><i>Product type selected</i></mat-hint>
                    <mat-error *ngIf="(f.itemtype.touched || submitted) && f.itemtype.hasError('required')">
                      <i>Product Type is required.</i>
                    </mat-error>
                  </mat-form-field>
                  <!--culture category-->
                  <mat-form-field appearance="outline" class="w-100" *ngIf="itemMaster.item_type_id == 1 || itemMaster.item_type_id == 2 || itemMaster.item_type_id == 13 || itemMaster.item_type_id == 14 || itemMaster.item_type_id == 16 || itemMaster.item_type_id == 17 || itemMaster.item_type_id == 18 || itemMaster.item_type_id == 19">
                    <mat-label>Culture Category</mat-label>
                    <mat-select id="category" [(ngModel)]="itemMaster.culture_category_id" formControlName="culturecatrgory"
                                (selectionChange)="getSpeciesTypeByCultureCategoryId(itemMaster.culture_category_id);itemMaster.species_type_id = undefined">
                      <mat-option value="" disabled>Select Culture Category</mat-option>
                      <mat-option *ngFor="let culturecategory of cultureCategories" [value]="culturecategory.id"> {{ culturecategory.name }} </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="f.culturecatrgory.invalid"><i>Select culture category</i></mat-hint>
                    <mat-hint *ngIf="f.culturecatrgory.valid"><i>Culture category selected</i></mat-hint>
                  </mat-form-field>
                  <!--species-->
                  <mat-form-field appearance="outline" class="w-100" *ngIf="itemMaster.item_type_id == 1 || itemMaster.item_type_id == 2 || itemMaster.item_type_id == 13 || itemMaster.item_type_id == 14 || itemMaster.item_type_id == 16 || itemMaster.item_type_id == 17 || itemMaster.item_type_id == 18 || itemMaster.item_type_id == 19">
                    <mat-label>Species</mat-label>
                    <mat-select id="species" [(ngModel)]="itemMaster.species_type_id" formControlName="species">
                      <mat-option value="" disabled>Select Species</mat-option>
                      <mat-option *ngFor="let species of dupSpeciesTypes" [value]="species.id"> {{ species.name }} </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="f.species.invalid"><i>Select species</i></mat-hint>
                    <mat-hint *ngIf="f.species.valid"><i>Species selected</i></mat-hint>
                  </mat-form-field>
                  <!--package type-->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Package Type</mat-label>
                    <mat-select id="uom_id" [(ngModel)]="itemMaster.uom_id" name="uom_id" formControlName="packagetype" (selectionChange)="onchangeUOM('tablefrom')">
                      <mat-option value="" disabled>Select Package Type</mat-option>
                      <mat-option *ngFor="let uom of uoms" [value]="uom.id"> {{ uom.name }} </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="f.packagetype.invalid"><i>Select package type</i></mat-hint>
                    <mat-hint *ngIf="f.packagetype.valid"><i>Package type selected</i></mat-hint>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-section">
                <div class="grid-three-cols">
                  <div class="row">
                    <!-- Stockable -->
                    <div class="col-md-12 col-xs-12">
                      <div class="form-group">
                        <label class="control-label">Stockable</label>
                        <div class="d-flex align-items-center gap-2">
                          <span>No</span>
                          <mat-slide-toggle [disabled]="isToggleDisabled" [(ngModel)]="itemMaster.stockable" [class.force-checked]="isToggleDisabled && registerForm.get('stockable')?.value"
                            formControlName="stockable" color="primary">
                          </mat-slide-toggle>
                          <span>Yes</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <!-- inventory/expense -->
                    <div class="col-md-12 col-xs-12">
                      <div class="form-group">
                        <label class="control-label">Is Inventory</label>
                        <div>
                          <label class="radio-inline">
                            <input type="radio" name="inventory" (selectionChange)="inventorycheck(); conversionBlock = false;"
                                   formControlName="inventory"
                                   [disabled]="itemMaster.stockable==undefined || (itemMaster.stockable == false && formAction == 'EDIT')"
                                   [(ngModel)]="itemMaster.isInventory" [value]="true">Inventory
                          </label>
                          <label class="radio-inline"
                                 *ngIf="itemMaster.item_type_id != 1 && itemMaster.item_type_id !=2">
                            <input type="radio" name="inventory" (selectionChange)="inventorycheck(); conversionBlock = false;"
                                   formControlName="inventory"
                                   [disabled]="itemMaster.stockable==undefined || (itemMaster.stockable == false && formAction == 'EDIT')"
                                   [(ngModel)]="itemMaster.isInventory" [value]="false">Expense
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label class="control-label">Conversion</label>
                        <div (click)="onclickconversionopen()">
                          <input type="checkbox" formControlName="conversion"
                                 *ngIf="itemMaster.isInventory && (!fromUOMName || !conversion.to_value || !toUOMName)"
                                 disabled><span class="conversionadd" *ngIf="itemMaster.isInventory && (!fromUOMName || !conversion.to_value || !toUOMName)">Click to Add</span>
                          <p class="editstyle" *ngIf="itemMaster.isInventory && (fromUOMName && conversion.to_value && toUOMName)">
                            {{ conversionfromvalue }}{{ fromUOMName }} = {{ conversion.to_value }} {{ toUOMName }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-section">
                <div class="grid-three-cols">
                  <!--reorder level-->
                  <mat-form-field appearance="outline" class="w-100" *ngIf="itemMaster.isInventory">
                    <mat-label>Reorder Level</mat-label>
                    <input matInput type="text" name="reordervalue" placeholder="Enter reorder level" formControlName="reordervalue" [(ngModel)]="itemMaster.reorder_level_value"
                           (change)="reorderValueNumber()" autocomplete="off"/>
                    <span matSuffix *ngIf="itemMaster.isInventory" class="purchase-text">{{ UOMName }}</span>
                    <mat-error *ngIf="f.reordervalue.value?.length > 0 && f.reordervalue.errors">
                      <i> {{ f.reordervalue.hasError('pattern') ? 'Only numbers allowed.' : '' }}</i>
                    </mat-error>
                  </mat-form-field>
                    <!--rom units uom id-->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="systemuomcondition == false && conversionBlock">
                      <mat-label>Package Type</mat-label>
                      <mat-select id="qpType" name="from_units_uom_id" formControlName="fromuomid" [(ngModel)]="conversion.from_units_uom_id" (selectionChange)="onchangeUOM('from')">
                        <mat-option value="" disabled>Select UOM</mat-option>
                        <mat-option *ngFor="let uom of systemuomdatatrue" [value]="uom.id"> {{ uom.name }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="form-field" *ngIf="systemuomcondition == true && conversionBlock">
                      <div class="uom-data">
                        <p>{{ fromUOMName }}</p>
                        <label style="top: 5px">Package type</label>
                      </div>
                      <!--if uom id -1 false-->
                    </div>
                    <!--to value-->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="conversionBlock">
                      <mat-label>Package Size</mat-label>
                      <input matInput type="text" name="tovalue" placeholder=" " formControlName="tovalue" [(ngModel)]="conversion.to_value"
                             (keypress)="decimalFilter($event)" autocomplete="off"/>
                      <mat-error *ngIf="f.tovalue.value?.length > 0 && f.tovalue.errors">
                        <i> {{ f.tovalue.hasError('pattern') ? 'Only numbers allowed.' : '' }}</i>
                      </mat-error>
                    </mat-form-field>
                    <!--to uom id-->
                    <mat-form-field appearance="outline" class="w-100" *ngIf="systemuomcondition == true && conversionBlock">
                      <mat-label>UOM</mat-label>
                      <mat-select id="to_units_uom_id" name="to_units_uom_id" formControlName="touomid" [(ngModel)]="conversion.to_units_uom_id" (selectionChange)="onchangeUOM('to')">
                        <mat-option [value]="null" disabled>Select UOM</mat-option>
                        <mat-option *ngFor="let uom of systemuomdatafalse" [value]="uom.id"> {{ uom.name }} </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="form-field" *ngIf="systemuomcondition==false && conversionBlock">
                      <div class="uom-data">
                        <p>{{ toUOMName }}</p>
                        <!--if uom id -1 true-->
                        <label style="top: 10px">UOM</label>
                      </div>
                    </div>
                </div>
              </div>
              <div class="form-section">
                <h3 class="section-title">Logo</h3>
                <div class="grid-three-cols modern-upload-grid">
                  <!-- Upload Card -->
                  <div class="file-upload-area" (click)="fileInput.click()">
                    <input type="file" #fileInput hidden accept="image/jpeg, image/jpg, image/png, image/webp" (change)="fileupload($event)" style="display: none;"/>
                    <div class="upload-icon">
                      <img src="assets/images/New_Icons/upload-square-svgrepo-com.svg" alt="upload square icon" width="28" height="28" />
                    </div>
                    <div class="upload-text">
                      <p class="upload-title">Click to Upload</p>
                      <p class="upload-subtitle">Accepted: JPG, JPEG, PNG, WEBP</p>
                    </div>
                  </div>
                  <!-- Preview -->
                  <div class="uploaded-preview" *ngIf="selectedbase64file">
                    <img [src]="selectedbase64file" alt="Uploaded Image" />
                    <button type="button" class="remove-btn" (click)="remove()" title="Remove"> ✕ </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--add/update form end-->
  </div>
</div>
